import { useQuery } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { OwnBankAccount } from './types';

export const getAllBankAccounts = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/bankAccounts`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOwnBankAccounts = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/bankAccount/own`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOwnBankAccountsQuery = (dispatch: Dispatch, enabled = true) =>
  useQuery({
    queryKey: ['bankAccounts', 'own'],
    queryFn: async (): Promise<OwnBankAccount[]> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/bankAccount/own`,
        dispatch,
      });
      if (!response) return [];
      const data = response.data;
      return Array.isArray(data) ? (data as OwnBankAccount[]) : [];
    },
    enabled,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

type BusinessBankAccount = {
  accountNumber: string;
  accountType: string;
  bankId: number;
  bankName: string;
  businessIdentifier: string;
  businessIsHolder: boolean;
  businessName: string;
  currency: string;
  email: string | null;
  holderIdentifier: string;
  holderName: string;
  id: number;
  powerDueDate: string | null;
  selected: boolean;
};

export const getBusinessBankAccounts = async (
  dispatch: Dispatch,
  businessId: string,
): Promise<BusinessBankAccount[]> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${businessId}/open/bankAccounts`,
    dispatch,
  });
  if (response) return response.data;
  return [];
};

export const createBusinessBankAccount = async (
  dispatch: Dispatch,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/bankAccounts`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteBusinessBankAccount = async (
  dispatch: Dispatch,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/business/${businessId}/open/bankAccounts/${data.bankAccountId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateBusinessBankAccount = async (
  dispatch: Dispatch,
  businessId: string,
  bankAccountId: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/business/${businessId}/open/bankAccounts/${bankAccountId}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const selectBankAccount = async (
  dispatch: Dispatch,
  businessId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/business/${businessId}/open/bankAccounts/${data.bankAccountId}/select`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getBankAccountById = async (
  dispatch: Dispatch,
  businessId: string,
  bankAccountId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${businessId}/open/bankAccounts/${bankAccountId}`,
    dispatch,
  });
  if (response) return response.data;
};
